<template>
    <div id="register">
        <mu-container>
            <mu-paper class="register_paper" :z-depth="2" >
                <mu-row>
                    <mu-col :span="3">
                    </mu-col>
                    <mu-col :span="6">
                        <mu-flex class="right_block" direction="column">
                            <mu-flex align-items="center" justify-content="center" style="width:100%;">
                                <h2>Logining</h2>
                            </mu-flex>
                        </mu-flex>
                    </mu-col>
                </mu-row>
            </mu-paper>
        </mu-container>
    </div>
</template>
<script>
import store from "@/vuex/store";

export default {
    data() {
        return {
            registerForm: {
            },
        };
    },

    methods: {
        refresh() {
            // 刷新
            location.href = location.href;
        }
    }
};
</script>
<style scoped>
@import "../../../assets/css/slideBlock.css";

#register {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.register_paper {
    background-color: #ffffff;
    box-shadow: 0 6px 20px 5px rgba(40, 120, 255, 0.1),
        0 16px 24px 2px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    overflow: hidden;
}

.left_block {
    height: 85vh;
    background: #4880ff;
    background: linear-gradient(311deg,
            rgba(115, 109, 255, 1) 0%,
            rgba(169, 127, 255, 1) 100%);
    box-shadow: 0 6px 20px 5px rgba(40, 120, 255, 0.1),
        0 16px 24px 2px rgba(0, 0, 0, 0.05);
    padding: 24px 36px;
}

.left_block .logo img {
    width: 32px;
    height: auto;
    margin-right: 8px;
}

.left_block .logo span {
    font-size: 24px;
    color: #ffffff;
    font-weight: 600;
    font-family: "DINCOND";
}

.right_block {
    height: 85vh;
    padding: 16px 48px;
    overflow: auto;
}

.right_block .register_form {
    width: 100%;
    margin: 48px 0px;
}

.right_block .mail_tip {
    margin-top: 24px;
    width: 100%;
}

.right_block .mail_tip p {
    color: #4e5a63;
    font-weight: 500;
}

.right_block .mail_tip span {
    margin: 8px 0px;
    color: #4e5a63;
    font-size: 12px;
    font-weight: 400;
}

.right_block .success_tip {
    color: #20253a;
    line-height: 28px;
    font-size: 14px;
    text-align: center;
}
</style>
  


// WEBPACK FOOTER //
// src/views/accessKey/Logining/index.vue